import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const BannerContext = createContext();

export const BannerContextProvider = ({ isBanner = false, children }) => {
  const [isBannerShown, setIsBannerShown] = useState(isBanner);
  return (
    <BannerContext.Provider value={{ isBannerShown, setIsBannerShown }}>
      {children}
    </BannerContext.Provider>
  );
};

BannerContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  isBanner: PropTypes.bool,
};
